module.exports = __webpack_public_path__ + "img/garage_active.386cf19d.svg";